



import {defineComponent, onMounted, PropType} from '@vue/composition-api';
import {RawTask} from '@/tasks/types/RawTask';

export default defineComponent({
  name: 'RemovedTask',
  props: {
    task: {
      type: Object as PropType<RawTask>,
      required: true,
    },
  },
  setup() {
    onMounted(() => {
      window.parent.postMessage({type: 'stemble:task-removed'}, '*');
    });
  },
});
